export type OrganizationChoice = {
  value: string;
  label: string;
  keywords?: string;
};

export const COUNTRY_CHOICES: OrganizationChoice[] = [
  ['IN', 'India'], ['US', 'United States'], ['GB', 'United Kingdom'],
  ['AE', 'United Arab Emirates'], ['SA', 'Saudi Arabia'], ['SG', 'Singapore'],
  ['MY', 'Malaysia'], ['AU', 'Australia'], ['CA', 'Canada'], ['DE', 'Germany'],
  ['FR', 'France'], ['NL', 'Netherlands'], ['IE', 'Ireland'], ['CH', 'Switzerland'],
  ['JP', 'Japan'], ['CN', 'China'], ['HK', 'Hong Kong'], ['NZ', 'New Zealand'],
  ['ZA', 'South Africa'], ['QA', 'Qatar'], ['KW', 'Kuwait'], ['OM', 'Oman'],
].map(([value, name]) => ({ value, label: `${name} (${value})`, keywords: name }));

export const TIME_ZONE_CHOICES: OrganizationChoice[] = [
  'Asia/Kolkata', 'Asia/Dubai', 'Asia/Riyadh', 'Asia/Qatar', 'Asia/Kuwait',
  'Asia/Muscat', 'Asia/Singapore', 'Asia/Kuala_Lumpur', 'Asia/Hong_Kong',
  'Asia/Shanghai', 'Asia/Tokyo', 'Australia/Sydney', 'Pacific/Auckland',
  'Europe/London', 'Europe/Dublin', 'Europe/Paris', 'Europe/Berlin',
  'Europe/Amsterdam', 'Europe/Zurich', 'Africa/Johannesburg', 'UTC',
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Toronto', 'America/Vancouver',
].map(value => ({ value, label: value, keywords: value.replace(/[_/]/g, ' ') }));

export const CURRENCY_CHOICES: OrganizationChoice[] = [
  ['INR', 'Indian Rupee'], ['USD', 'US Dollar'], ['EUR', 'Euro'],
  ['GBP', 'British Pound'], ['AED', 'UAE Dirham'], ['SAR', 'Saudi Riyal'],
  ['SGD', 'Singapore Dollar'], ['MYR', 'Malaysian Ringgit'],
  ['AUD', 'Australian Dollar'], ['CAD', 'Canadian Dollar'],
  ['CHF', 'Swiss Franc'], ['JPY', 'Japanese Yen'], ['CNY', 'Chinese Yuan'],
  ['HKD', 'Hong Kong Dollar'], ['NZD', 'New Zealand Dollar'],
  ['ZAR', 'South African Rand'], ['QAR', 'Qatari Riyal'],
  ['KWD', 'Kuwaiti Dinar'], ['OMR', 'Omani Rial'],
].map(([value, name]) => ({ value, label: `${value} — ${name}`, keywords: name }));

export const DATE_FORMAT_CHOICES: OrganizationChoice[] = [
  { value: 'dd/MM/yyyy', label: 'dd/MM/yyyy — 31/12/2026' },
  { value: 'dd-MM-yyyy', label: 'dd-MM-yyyy — 31-12-2026' },
  { value: 'MM/dd/yyyy', label: 'MM/dd/yyyy — 12/31/2026' },
  { value: 'yyyy-MM-dd', label: 'yyyy-MM-dd — 2026-12-31' },
  { value: 'dd MMM yyyy', label: 'dd MMM yyyy — 31 Dec 2026' },
  { value: 'MMM dd, yyyy', label: 'MMM dd, yyyy — Dec 31, 2026' },
];

export const TIME_FORMAT_CHOICES: OrganizationChoice[] = [
  { value: 'hh:mm tt', label: 'hh:mm tt — 05:30 PM', keywords: '12 hour' },
  { value: 'hh:mm:ss tt', label: 'hh:mm:ss tt — 05:30:45 PM', keywords: '12 hour seconds' },
  { value: 'HH:mm', label: 'HH:mm — 17:30', keywords: '24 hour' },
  { value: 'HH:mm:ss', label: 'HH:mm:ss — 17:30:45', keywords: '24 hour seconds' },
];
